export enum InferenceTypes {
    OWLVIT = "owlvit",
    SEG_PREVIEW = "seg-preview",
    WORKFLOW = "workflow",
    WORKFLOW_PUBLIC = "workflow-public" // used for shared workflow runs
}

export enum InferenceStreamEvents {
    STARTED = "inference-started",
    ITEM_INFERRED = "inference-result",
    COMPLETE = "inference-complete",
    ERROR = "inference-error",
    ABORTED = "inference-aborted"
}

// Individual inference item (could be image URL, frame data, etc.)
export interface InferenceItem {
    id: string;
    data: any;
}

// Data provider interface - abstracts how we get inference items
export interface InferenceDataProvider {
    getItems(): AsyncGenerator<InferenceItem>;
}

// Base streaming event
export interface StreamEvent {
    event: InferenceStreamEvents;
    data: Record<string, any>;
}

// CommonJS exports for Node.js compatibility
export default { InferenceTypes, InferenceStreamEvents };
